import React from 'react'
import Svg, { G, Path, SvgProps } from 'react-native-svg'

import { Color } from '../../style'

export interface Props extends SvgProps {}
const IconLocation = (props: Props) => {
  const { width, height, color, ...otherProps } = props
  return (
    <Svg
      width={width}
      height={height}
      viewBox={`0 0 ${IconLocation.dimensions.width} ${IconLocation.dimensions.height}`}
      {...otherProps}
    >
      <G fill="none" fillRule="evenodd">
        <Path
          stroke={color || Color.premiumBlack}
          strokeWidth={0.75}
          d="M12.586 6.492h12.305l6.476 17.143H1.28L6.627 6.648"
        />
        <Path stroke={color || Color.premiumBlack} strokeWidth={0.75} d="M4.594 13.104h9.228l.158 10.53" />
        <Path stroke={color || Color.premiumBlack} strokeWidth={0.75} d="M17.74 23.635v-3.97l12.137.016" />
        <Path stroke={color || Color.premiumBlack} strokeWidth={0.75} d="M27.23 12.388h-7.668l-.508-5.896" />
        <Path
          d="M5.873 4.076c.062-.259.106-.518.176-.768C6.557 1.469 8.327.226 10.062.485c1.929.285 3.357 1.908 3.322 3.902-.009.604-.202 1.234-.42 1.804-.79 2.089-1.92 3.988-3.077 5.86-.131.217-.289.303-.447.035-1.262-2.063-2.524-4.134-3.304-6.465-.114-.337-.175-.69-.263-1.044v-.51.01Zm3.681 7.544.132-.034c1.121-1.882 2.26-3.755 3.006-5.853.166-.466.298-.984.271-1.467C12.867 2.074 11.035.58 8.985.977 7.109 1.34 5.89 3.394 6.452 5.31c.184.64.43 1.278.727 1.865.763 1.502 1.578 2.978 2.367 4.462l.008-.017Z"
          stroke="#0B0907"
          strokeWidth={0.25}
          fill="#0B0907"
          fillRule="nonzero"
        />
        <Path
          d="M9.66 2.03c1.253 0 2.26 1.07 2.26 2.39 0 1.312-1.025 2.391-2.27 2.383-1.243 0-2.26-1.08-2.26-2.4 0-1.32 1.008-2.374 2.27-2.374Zm1.849 2.399c.008-1.088-.806-1.96-1.832-1.968-1.034 0-1.866.846-1.875 1.925 0 1.079.815 1.96 1.831 1.976 1.008.018 1.867-.871 1.876-1.933Z"
          stroke={color || Color.premiumBlack}
          strokeWidth={0.25}
          fill="#0B0907"
          fillRule="nonzero"
        />
      </G>
    </Svg>
  )
}

IconLocation.dimensions = {
  width: 32,
  height: 25,
}

export default IconLocation
